/* Restwell theme scripts. No libraries. */
(() => {
  const R = window.Restwell || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  const money = (cents, fmt) => {
    fmt = fmt || R.money || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const fix = (d, sep, dec) => {
      const p = n.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return d ? p.join(dec) : p[0];
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fix(2, ',', '.'),
      amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','),
      amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.')
    }[k] || fix(2, ',', '.')));
  };
  window.RestwellMoney = money;

  /* ---------- toast ---------- */
  let toastEl, toastT;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };

  /* ---------- header ---------- */
  const head = $('[data-header]');
  if (head) {
    const onScroll = () => head.classList.toggle('is-scrolled', scrollY > 8);
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- overlays (menu + cart) ---------- */
  let lastFocus = null;
  const openLayer = (el) => {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 60);
  };
  const closeLayer = (el) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  const nav = $('#mobileNav');
  const burger = $('[data-nav-open]');
  burger && burger.addEventListener('click', () => { openLayer(nav); burger.setAttribute('aria-expanded', 'true'); });
  $$('[data-nav-close]').forEach(b => b.addEventListener('click', () => { closeLayer(nav); burger && burger.setAttribute('aria-expanded', 'false'); }));
  addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeLayer(nav); closeLayer(drawer); }
  });

  /* ---------- reveal on scroll ---------- */
  const revealEls = $$('.reveal, .steps-grid');
  if ('IntersectionObserver' in window && !reduce) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-in'));
  }

  /* ---------- count up numbers ---------- */
  const counters = $$('[data-count]');
  if (counters.length) {
    const run = (el) => {
      const end = parseFloat(el.dataset.count) || 0;
      const dec = parseInt(el.dataset.decimals || '0', 10);
      if (reduce) { el.textContent = end.toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }); return; }
      const t0 = performance.now(), dur = 1600;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (end * e).toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const io2 = new IntersectionObserver((en) => en.forEach(x => { if (x.isIntersecting) { run(x.target); io2.unobserve(x.target); } }), { threshold: 0.6 });
    counters.forEach(c => { c.textContent = '0'; io2.observe(c); });
  }

  /* ---------- day tabs ---------- */
  $$('[data-day]').forEach(sec => {
    const tabs = $$('.day-tab', sec);
    const orb = $('[data-day-orb]', sec);
    const place = (i) => {
      if (!orb) return;
      const n = tabs.length;
      const t = n > 1 ? 0.06 + (i / (n - 1)) * 0.88 : 0.5;
      // same cubic curve as the svg path: M20 160 C 260 -40, 740 -40, 980 160 (viewBox 1000 x 170)
      const u = 1 - t;
      const x = u * u * u * 20 + 3 * u * u * t * 260 + 3 * u * t * t * 740 + t * t * t * 980;
      const y = u * u * u * 160 + 3 * u * u * t * -40 + 3 * u * t * t * -40 + t * t * t * 160;
      orb.style.left = (x / 10) + '%';
      orb.style.top = (y / 170 * 100) + '%';
      orb.classList.toggle('is-night', i === n - 1 && n > 2);
    };
    const select = (i, focus) => {
      tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      sec.style.setProperty('--day-bg', tabs[i].dataset.color);
      place(i);
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') select((i + 1) % tabs.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + tabs.length) % tabs.length, true);
      });
    });
    if (tabs.length) select(0);
  });

  /* ---------- timeline fill ---------- */
  $$('[data-tl]').forEach(list => {
    const fill = $('[data-tl-fill]', list);
    if (!fill) return;
    let ticking = false;
    const upd = () => {
      ticking = false;
      const r = list.getBoundingClientRect();
      const mid = innerHeight * 0.6;
      const p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
      fill.style.height = (p * 100) + '%';
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  });

  /* ---------- before / after ---------- */
  $$('[data-ba]').forEach(f => {
    const r = $('.ba-range', f);
    const set = () => f.style.setProperty('--pos', r.value + '%');
    r.addEventListener('input', set);
    set();
  });

  /* ---------- cart ---------- */
  const drawer = $('#cartDrawer');
  const lines = drawer && $('[data-cart-lines]', drawer);

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const setCount = (n) => $$('[data-cart-count]').forEach(el => { el.textContent = n; if (el.classList.contains('cart-dot')) el.hidden = n === 0; });

  const renderCart = (cart) => {
    setCount(cart.item_count);
    if (!drawer) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="drawer-empty"><p>Your cart is empty for now.</p><a class="btn btn-accent" href="' + (R.routes ? R.routes.root : '/') + 'collections/all">Shop the ritual</a></div>';
    } else {
      lines.innerHTML = cart.items.map((it, i) => {
        const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        const variant = it.variant_title && it.product_has_only_default_variant === false ? '<p>' + esc(it.variant_title) + '</p>' : '';
        const disc = (it.line_level_discount_allocations || []).map(d => '<p class="disc">' + esc(d.discount_application.title) + ' (-' + money(d.amount) + ')</p>').join('');
        const was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="dline" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="76" height="76" loading="lazy">' : '<span></span>') +
          '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + variant + disc +
          '<div class="qty" style="margin-top:8px"><button type="button" data-q="-1" aria-label="One less">&minus;</button><input type="number" min="0" value="' + it.quantity + '" aria-label="Quantity" data-qin><button type="button" data-q="1" aria-label="One more">+</button></div></div>' +
          '<div class="dline-right"><strong>' + money(it.final_line_price) + '</strong>' + was + '</div></div>';
      }).join('');
    }
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    const sav = $('[data-cart-savings]', drawer);
    if (sav) {
      sav.hidden = !(cart.total_discount > 0);
      $('[data-cart-savings-amt]', drawer).textContent = '-' + money(cart.total_discount);
    }
    const bar = $('[data-ship-bar]', drawer);
    if (bar && R.freeShip > 0) {
      const left = R.freeShip - cart.total_price;
      $('[data-ship-text]', bar).textContent = left > 0 ? 'You are ' + money(left) + ' away from free shipping' : 'Free shipping is on us';
      $('[data-ship-fill]', bar).style.width = Math.min(100, (cart.total_price / R.freeShip) * 100) + '%';
    }
  };

  const getCart = () => fetch((R.routes ? R.routes.cart : '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());

  const openCart = () => getCart().then(c => { renderCart(c); openLayer(drawer); });

  if (drawer && R.cartDrawer !== false) {
    $$('[data-open-cart]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openCart(); }));
    $$('[data-close-cart]', drawer).forEach(b => b.addEventListener('click', () => closeLayer(drawer)));
    lines.addEventListener('click', e => {
      const b = e.target.closest('[data-q]');
      if (!b) return;
      const row = b.closest('[data-line]');
      const inp = $('[data-qin]', row);
      changeLine(row.dataset.line, Math.max(0, parseInt(inp.value, 10) + parseInt(b.dataset.q, 10)));
    });
    lines.addEventListener('change', e => {
      if (!e.target.matches('[data-qin]')) return;
      changeLine(e.target.closest('[data-line]').dataset.line, Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  function changeLine(line, quantity) {
    lines.classList.add('is-busy');
    fetch((R.routes ? R.routes.cartChange : '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity })
    }).then(r => r.json()).then(renderCart).finally(() => lines.classList.remove('is-busy'));
  }

  const addItems = (items) => fetch((R.routes ? R.routes.cartAdd : '/cart/add') + '.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items })
  }).then(async r => {
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || (R.text && R.text.error));
    return data;
  });

  const afterAdd = () => {
    if (drawer && R.cartDrawer !== false) openCart();
    else { getCart().then(c => setCount(c.item_count)); toast(R.text ? R.text.added : 'Added'); }
  };
  window.RestwellCart = { addItems, afterAdd, toast };

  /* quick add (product cards) */
  document.addEventListener('submit', e => {
    const f = e.target.closest('[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('button');
    btn.classList.add('is-busy');
    addItems([{ id: Number(f.querySelector('[name=id]').value), quantity: 1 }])
      .then(afterAdd).catch(err => toast(err.message)).finally(() => btn.classList.remove('is-busy'));
  });

  /* routine (add several) */
  $$('[data-routine]').forEach(f => {
    const total = $('[data-routine-total]', f);
    const rows = $$('.routine-item', f);
    const calc = () => {
      let sum = 0;
      rows.forEach(r => {
        const cb = $('input[type=checkbox]', r);
        const sel = $('select', r);
        r.classList.toggle('is-off', !cb.checked);
        if (cb.checked) sum += Number(sel ? sel.selectedOptions[0].dataset.price : cb.dataset.price);
      });
      total.textContent = money(sum);
    };
    f.addEventListener('change', calc);
    f.addEventListener('submit', e => {
      e.preventDefault();
      const items = rows.filter(r => $('input[type=checkbox]', r).checked).map(r => {
        const sel = $('select', r);
        return { id: Number(sel ? sel.value : $('input[name$="[id]"]', r).value), quantity: 1 };
      });
      if (!items.length) { toast('Pick at least one item'); return; }
      const btn = $('button[type=submit]', f);
      btn.classList.add('is-busy');
      addItems(items).then(afterAdd).catch(err => toast(err.message)).finally(() => btn.classList.remove('is-busy'));
    });
    calc();
  });

  /* cart page steppers */
  $$('[data-cart-page] .qty').forEach(q => {
    const inp = $('input', q);
    $$('[data-step]', q).forEach(b => b.addEventListener('click', () => {
      inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.step, 10));
      q.closest('form').requestSubmit ? q.closest('form').requestSubmit($('[name=update]', q.closest('form'))) : q.closest('form').submit();
    }));
  });

  /* ---------- product page ---------- */
  $$('[data-pm]').forEach(pm => {
    const cfg = JSON.parse(($('[data-pm-json]', pm) || {}).textContent || '{}');
    const fmt = cfg.money;
    const track = $('[data-track]', pm);
    const slides = track ? $$('.pm-slide', track) : [];
    const thumbs = $$('[data-thumb]', pm);

    /* gallery */
    const goTo = (i, smooth = true) => {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    if (track) {
      let t;
      track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => { const i = current(); thumbs.forEach((b, j) => b.classList.toggle('is-on', i === j)); }, 60);
      }, { passive: true });
      thumbs.forEach(b => b.addEventListener('click', () => goTo(Number(b.dataset.thumb))));
      const prev = $('[data-prev]', pm), next = $('[data-next]', pm);
      prev && prev.addEventListener('click', () => goTo((current() - 1 + slides.length) % slides.length));
      next && next.addEventListener('click', () => goTo((current() + 1) % slides.length));
      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current() + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current() - 1)); }
      });
    }
    /* gallery film: play while it is the visible slide */
    const film = track && $('[data-film] video', track);
    if (film && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        if (en.isIntersecting && en.intersectionRatio > 0.6) film.play().catch(() => {});
        else film.pause();
      }, { root: null, threshold: [0, 0.6, 1] }).observe(film);
    }
    const showMedia = (id) => {
      if (!id) return;
      const i = slides.findIndex(s => s.dataset.mediaId === String(id));
      if (i > -1) goTo(i);
    };

    /* bundles + variants */
    const form = $('[data-pm-form]', pm) || $('#pmForm', pm);
    const bundles = $$('.pm-bundle', pm);
    const mixRows = $$('.pm-mix-row', pm);
    const qtyInput = $('[data-qty-input]', pm);
    const addBtn = $('[data-add]', pm);
    const addTotal = $('[data-add-total]', pm);
    const errEl = $('[data-error]', pm);

    const chosenBundle = () => bundles.find(b => b.querySelector('input').checked);
    const unitPrice = () => {
      const sw = form && form.querySelector('.pm-swatches input:checked');
      if (sw) return Number(sw.dataset.price);
      const first = mixRows[0] && $('select', mixRows[0]);
      if (first) return Number(first.selectedOptions[0].dataset.price);
      return Number(cfg.unit);
    };

    // Shopify takes the % off each item and rounds down, so do the same here
    const afterOff = (cents, d) => cents - Math.floor(cents * d / 100);
    const refresh = () => {
      const b = chosenBundle();
      const qty = b ? Number(b.querySelector('input').dataset.qty) : 1;
      const disc = b ? Number(b.querySelector('input').dataset.discount) : 0;
      bundles.forEach(x => x.classList.toggle('is-on', x === b));
      /* the colour pickers sit inside the chosen bundle */
      const mixBox = $('[data-mix]', pm);
      if (mixBox && b) {
        const item = b.closest('.pm-bundle-item');
        if (item && mixBox.parentNode !== item) item.appendChild(mixBox);
        $$('.pm-bundle-item', pm).forEach(it => it.classList.toggle('has-mix', it === item));
      }

      // rows for mix and match
      mixRows.forEach((row, i) => {
        const on = i < qty;
        row.hidden = !on;
        $$('select, input', row).forEach(el => { el.disabled = !on; });
      });
      if (qtyInput) qtyInput.value = qty;

      // per-bundle prices (based on current colour choice)
      const unit = unitPrice();
      bundles.forEach(x => {
        const inp = x.querySelector('input');
        const q = Number(inp.dataset.qty), d = Number(inp.dataset.discount);
        let prices = Array(q).fill(unit);
        if (x === b && mixRows.length) prices = mixRows.slice(0, q).map(r => Number($('select', r).selectedOptions[0].dataset.price));
        const full = prices.reduce((s, p) => s + p, 0);
        const price = prices.reduce((s, p) => s + afterOff(p, d), 0);
        const bp = $('[data-bprice]', x), bf = $('[data-bfull]', x), be = $('[data-beach]', x);
        if (bp) bp.textContent = money(price, fmt);
        if (bf) bf.textContent = money(full, fmt);
        if (be) be.textContent = money(Math.floor(price / q), fmt) + ' ' + (cfg.each || 'each');
      });

      // button total
      let prices = Array(qty).fill(unit);
      if (mixRows.length) prices = mixRows.slice(0, qty).map(r => Number($('select', r).selectedOptions[0].dataset.price));
      const full = prices.reduce((s, p) => s + p, 0);
      const pay = prices.reduce((s, p) => s + afterOff(p, disc), 0);
      if (addTotal && bundles.length) addTotal.innerHTML = (disc > 0 ? '<s>' + money(full, fmt) + '</s>' : '') + money(pay, fmt);
      const sp = $('[data-sticky-price]', pm);
      if (sp) sp.textContent = bundles.length ? (b ? b.querySelector('.pm-bname strong').firstChild.textContent.trim() + ' · ' : '') + money(pay, fmt) : money(unit, fmt);
      const up = $('[data-unit-price]', pm);
      if (up) up.textContent = money(unit, fmt);
    };

    bundles.forEach(b => b.addEventListener('click', () => { b.querySelector('input').checked = true; refresh(); }));
    form && form.addEventListener('change', e => {
      if (e.target.matches('.pm-swatches input')) showMedia(e.target.dataset.media);
      if (e.target.matches('[data-mix-select]')) showMedia(e.target.selectedOptions[0].dataset.media);
      refresh();
    });

    form && form.addEventListener('submit', e => {
      e.preventDefault();
      errEl && (errEl.hidden = true);
      let items = [];
      const b = chosenBundle();
      const qty = b ? Number(b.querySelector('input').dataset.qty) : 1;
      if (mixRows.length) {
        const map = {};
        mixRows.slice(0, qty).forEach(r => { const id = $('select', r).value; map[id] = (map[id] || 0) + 1; });
        items = Object.keys(map).map(id => ({ id: Number(id), quantity: map[id] }));
      } else {
        const idEl = form.querySelector('.pm-swatches input:checked') || form.querySelector('[name=id]');
        items = [{ id: Number(idEl.value), quantity: qty }];
      }
      const label = $('[data-add-label]', addBtn);
      const old = label.textContent;
      label.textContent = (R.text && R.text.adding) || 'Adding...';
      addBtn.classList.add('is-busy');
      addItems(items).then(afterAdd).catch(err => {
        if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
      }).finally(() => { label.textContent = old; addBtn.classList.remove('is-busy'); });
    });

    /* sticky bar */
    const sticky = $('[data-sticky]', pm);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const sbtn = $('[data-sticky-btn]', sticky);
      const io3 = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sbtn.tabIndex = show ? 0 : -1;
      });
      io3.observe(addBtn);
      sbtn.addEventListener('click', () => {
        document.getElementById('buy').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      });
    }

    refresh();
  });
})();
